// client/table/x-sorting-card.ts
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-flex.js";
import { DesignSystem } from "@adornis/chemistry/elements/theming/design.js";
import { stateful, useObservable } from "@adornis/functional-lit/stateful.js";
import { html } from "lit";
var styles = {
  ".sorting-card": {
    position: "relative",
    background: "var(--color-base-content)",
    borderRadius: "var(--radius-box)",
    color: "var(--color-base)",
    fontSize: "0.75rem",
    cursor: "pointer",
    // marginLeft: DesignSystem.spacing.xs,
    // padding: `${DesignSystem.spacing.xxs} ${DesignSystem.spacing.xs}`,
    transition: "all 0.125s ease-in",
    "&:hover": {
      background: "var(--color-base-200)"
    }
  },
  ".sorting-number": {
    position: "absolute",
    top: "-4px",
    right: "-4px",
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    background: "var(--color-primary)",
    fontSize: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  ".sorting-icon": {
    width: "12px",
    height: "12px",
    transition: "transform 0.125s ease-in"
  }
};
var XSortingCard = stateful(
  ({
    sortingDirection,
    sortingNumber,
    onUpdated
  }) => {
    const design = useObservable(() => DesignSystem.currentTheme, []);
    const handleClose = (e) => {
      e.stopPropagation();
      onUpdated?.(new CustomEvent("updated", { detail: { sortingDirection: void 0 } }));
    };
    return html`
      <div class="sorting-card flex flex-row justify-center items-center" ${css(styles)}>
        <x-flex
          class="sorting-icon"
          ${css({
      transform: sortingDirection === "asc" ? "rotate(0deg)" : "rotate(180deg)"
    })}
        >
          ↑
        </x-flex>
        <div class="sorting-number">${sortingNumber + 1}</div>
        <x-flex
          class="close-button"
          @click=${handleClose}
          ${css({
      marginLeft: design?.spacing.xs,
      cursor: "pointer",
      "&:hover": {
        opacity: 0.7
      }
    })}
        >
          ✕
        </x-flex>
      </div>
    `;
  }
);
export {
  XSortingCard
};
